"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Envelope = _interopRequireDefault(require("../../geom/Envelope"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MonotoneChain =
/*#__PURE__*/
function () {
  function MonotoneChain() {
    _classCallCheck(this, MonotoneChain);

    MonotoneChain.constructor_.apply(this, arguments);
  }

  _createClass(MonotoneChain, [{
    key: "getLineSegment",
    value: function getLineSegment(index, ls) {
      ls.p0 = this._pts[index];
      ls.p1 = this._pts[index + 1];
    }
  }, {
    key: "computeSelect",
    value: function computeSelect(searchEnv, start0, end0, mcs) {
      var p0 = this._pts[start0];
      var p1 = this._pts[end0];

      if (end0 - start0 === 1) {
        mcs.select(this, start0);
        return null;
      }

      if (!searchEnv.intersects(p0, p1)) return null;
      var mid = Math.trunc((start0 + end0) / 2);

      if (start0 < mid) {
        this.computeSelect(searchEnv, start0, mid, mcs);
      }

      if (mid < end0) {
        this.computeSelect(searchEnv, mid, end0, mcs);
      }
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      var coord = new Array(this._end - this._start + 1).fill(null);
      var index = 0;

      for (var i = this._start; i <= this._end; i++) {
        coord[index++] = this._pts[i];
      }

      return coord;
    }
  }, {
    key: "computeOverlaps",
    value: function computeOverlaps() {
      if (arguments.length === 2) {
        var mc = arguments[0],
            mco = arguments[1];
        this.computeOverlaps(this._start, this._end, mc, mc._start, mc._end, mco);
      } else if (arguments.length === 6) {
        var start0 = arguments[0],
            end0 = arguments[1],
            _mc = arguments[2],
            start1 = arguments[3],
            end1 = arguments[4],
            _mco = arguments[5];

        if (end0 - start0 === 1 && end1 - start1 === 1) {
          _mco.overlap(this, start0, _mc, start1);

          return null;
        }

        if (!this.overlaps(start0, end0, _mc, start1, end1)) return null;
        var mid0 = Math.trunc((start0 + end0) / 2);
        var mid1 = Math.trunc((start1 + end1) / 2);

        if (start0 < mid0) {
          if (start1 < mid1) this.computeOverlaps(start0, mid0, _mc, start1, mid1, _mco);
          if (mid1 < end1) this.computeOverlaps(start0, mid0, _mc, mid1, end1, _mco);
        }

        if (mid0 < end0) {
          if (start1 < mid1) this.computeOverlaps(mid0, end0, _mc, start1, mid1, _mco);
          if (mid1 < end1) this.computeOverlaps(mid0, end0, _mc, mid1, end1, _mco);
        }
      }
    }
  }, {
    key: "setId",
    value: function setId(id) {
      this._id = id;
    }
  }, {
    key: "select",
    value: function select(searchEnv, mcs) {
      this.computeSelect(searchEnv, this._start, this._end, mcs);
    }
  }, {
    key: "getEnvelope",
    value: function getEnvelope() {
      if (this._env === null) {
        var p0 = this._pts[this._start];
        var p1 = this._pts[this._end];
        this._env = new _Envelope.default(p0, p1);
      }

      return this._env;
    }
  }, {
    key: "overlaps",
    value: function overlaps(start0, end0, mc, start1, end1) {
      return _Envelope.default.intersects(this._pts[start0], this._pts[end0], mc._pts[start1], mc._pts[end1]);
    }
  }, {
    key: "getEndIndex",
    value: function getEndIndex() {
      return this._end;
    }
  }, {
    key: "getStartIndex",
    value: function getStartIndex() {
      return this._start;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this._context;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MonotoneChain;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return MonotoneChain;
}();

exports.default = MonotoneChain;

MonotoneChain.constructor_ = function () {
  this._pts = null;
  this._start = null;
  this._end = null;
  this._env = null;
  this._context = null;
  this._id = null;
  var pts = arguments[0],
      start = arguments[1],
      end = arguments[2],
      context = arguments[3];
  this._pts = pts;
  this._start = start;
  this._end = end;
  this._context = context;
};